import React from "react";
import {sortFn} from '../../components/utils/datautils'
import './table.css'

const Table = ({data, cols, sortColumns, headers, formatters, onHeaderClick}) => {
    const hasData = data && data.length
    return <div className={"tableWrapper"}>
        {hasData ?
            <table >
                <thead><tr>
                    {cols.map(
                        ( o, i ) => headers[i]( "th", o, {
                            key :           i,
                            onClick :       onHeaderClick,
                            className :     (sortColumns[0] && sortColumns[0].index == i) ? sortColumns[0].direction : '',
                            'data-column' : i,
                        } )
                    )}
                </tr></thead>
                <tbody>
                {data.sort(sortFn(sortColumns)).map(( row, i ) => (
                <tr key={i}>
                    {row.map(
                        ( cell, j ) => formatters[j]( "td" , cell, {key:j} )
                    )}
                </tr>
                ))}
                </tbody>
            </table>
            : <span className={"noData"}></span>
        }
    </div>
}

export default Table